var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-2"},[_c('v-chip',{attrs:{"small":""}},[_c('v-icon',{attrs:{"small":"","color":_vm.severityColor,"left":""}},[_vm._v("mdi-thermometer-lines")]),_vm._v(" "+_vm._s(_vm.severityName)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }